<template>
    <router-link
        class="vehicle-mini-link"
        :to="'/balise/' + balise.id"
        :title="balise.name || 'Véhicule'"
        @click.stop
    >
        <span class="vehicle-mini-icon" aria-hidden="true">
            <VehicleIcon :icon="balise.icon" />
        </span>
        <span class="vehicle-mini-name">
            {{ balise.name || ('Véhicule #' + balise.id) }}
        </span>
    </router-link>
</template>

<script>
import VehicleIcon from '@/components/display/VehicleIcon.vue';

export default {
    name: 'VehicleMiniLink',
    components: { VehicleIcon },
    props: {
        balise: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped>
.vehicle-mini-link {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    padding: 0.25rem 0.6rem 0.25rem 0.25rem;
    max-width: 100%;
    min-width: 0;
    border: 1px solid #e2e8f0;
    border-radius: 0.55rem;
    background: #fff;
    color: #1f2937;
    text-decoration: none;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.vehicle-mini-link:hover,
.vehicle-mini-link:focus-visible {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #0f172a;
    text-decoration: none;
}

.vehicle-mini-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
}

.vehicle-mini-icon :deep(.icon-block),
.vehicle-mini-icon :deep(.icon-mapdisplay) {
    width: 36px;
    height: 36px;
}

.vehicle-mini-icon :deep(.icon-mapdisplay) {
    object-fit: contain;
}

.vehicle-mini-icon :deep(svg) {
    width: 28px;
    height: 28px;
}

.vehicle-mini-name {
    display: block;
    min-width: 0;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
    font-weight: 600;
}
</style>
